import { useRef } from "react";

// initially for use together with ClickAwayListener library, it prevents from closing modal or sth when starting click inside modal and ending click outside modal - and vice versa
export const useHandleClickAway = (clickAwayHandler: () => void) => {
  const areaRef = useRef<HTMLDivElement>(null);
  const isMouseDownInside = useRef<boolean>(false);

  const handleMouseDown = () => {
    isMouseDownInside.current = true;
  };

  const handleMouseUp = () => {
    if (isMouseDownInside.current) {
      // Mouse was pressed inside the area
      isMouseDownInside.current = false;
    } else {
      // Mouse was pressed outside the area but released inside
      isMouseDownInside.current = true;
    }
  };

  const handleClickAway = (event: MouseEvent | TouchEvent): void => {
    if (!isMouseDownInside.current && areaRef.current && !areaRef.current.contains(event.target as Node)) {
      clickAwayHandler();
    } else {
      isMouseDownInside.current = false;
    }
  };

  return {
    handleMouseUp,
    handleMouseDown,
    handleClickAway,
    areaRef,
  };
};
